export default () => ({
    counts: {},
    entities: {},
})
